let retryQueue = [];
let listeners = [];
let timer = null;

const RETRY_DELAY = 10000;
const MAX_RETRY = 3;

export const subscribeRetryQueue = (fn) => {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
};

const notify = () => {
  listeners.forEach((fn) => fn(retryQueue));
};

export const enqueueRetry = (job) => {
  retryQueue.push({ ...job, retry: 0 });
  notify();
  schedule();
};

const schedule = () => {
  if (timer || retryQueue.length === 0) return;

  timer = setTimeout(async () => {
    timer = null;
    await processRetryQueue();
  }, RETRY_DELAY);
};

export const processRetryQueue = async () => {
  for (const job of [...retryQueue]) {
    try {
      await job.action();
      retryQueue = retryQueue.filter((j) => j !== job);
    } catch (err) {
      console.log(err);
      job.retry++;
      if (job.retry >= MAX_RETRY) {
        retryQueue = retryQueue.filter((j) => j !== job);
      }
    }
  }

  notify();
  schedule();
};
